/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect, useState } from 'react';
import { HomeContainer, States } from '@/features/eventClose/screens/Home/ui';
import { useHistory, useParams } from 'react-router-dom';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import api from '@/services/api';
import EventClose from '@/model/EventClose';
import { useConfirmDelete } from '@/hooks/useConfirmDelete';
import { CloseEventContent } from '../../components/CloseEventContent';

export const HomeEventCloseScreen: React.FC = (): JSX.Element => {
  const [state, setState] = useState<States>(States.default);
  const [eventState, setEventState] = useState<EventClose>();
  const { id: eventId } = useParams<{ id: string }>();

  const confirmDelete = useConfirmDelete();
  const history = useHistory();

  const handleGetEventClose = async (id: string): Promise<void> => {
    try {
      setState(States.loading);
      const { data } = await api.get<EventClose>(`/event-close/${id}`);
      setEventState(data);
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  const handleOnClose = (): void => confirmDelete.hide();

  const handleOnCloseEvent = async (): Promise<void> => {
    try {
      setState(States.loading);
      await api.patch(`/event/close/${eventId}/end`);
      handleOnClose();
      history.push('/financial/event-close');
    } finally {
      setState(States.default);
    }
  };

  const handleOnShowCloseEvent = (): void => {
    confirmDelete.show({
      title: '',
      children: <CloseEventContent />,
      actions: [
        {
          title: 'Não, quero manter',
          theme: 'noneBorder',
          onClick: (): void => handleOnClose(),
        },
        {
          title: 'Sim, quero fechar',
          onClick: (): Promise<void> => handleOnCloseEvent(),
        },
      ],
    });
  };

  useEffect(() => {
    handleGetEventClose(eventId);
  }, []);

  return (
    <HomeContainer state={state} eventState={eventState} closeEvent={handleOnShowCloseEvent} />
  );
};
